import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "forgotPassword",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  tabindex: "-1",
  "aria-labelledby": "forgotPasswordLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h5", {
  class: "modal-title",
  id: "staticBackdropLabel"
}, "Forgot Password", -1)
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = {
  key: 0,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "text-primary" }, " Enter the email address you registered with ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  for: "Email",
  class: "form-label"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-envelope" }),
  /*#__PURE__*/_createTextVNode(" Email")
], -1)
const _hoisted_10 = {
  key: 1,
  class: "text-info"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-circle" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" We will send you an email with a reset link")
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = {
  key: 2,
  class: "text-success"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check-circle" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Email was successfully sent.")
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = { class: "dialog-footer text-center d-grid gap-2 p-3" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("small", null, "Reset Password", -1)
const _hoisted_21 = [
  _hoisted_20
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)))
          })
        ]),
        _createVNode(_component_Form, { onSubmit: _ctx.resetPassword }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              (_ctx.email_fail)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, " We are unable to find your email. Please try again! "))
                : _createCommentVNode("", true),
              _hoisted_8,
              _createVNode(_component_Field, {
                name: "Email",
                rules: { required: true, email: true },
                modelValue: _ctx.EmailAddress,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.EmailAddress) = $event))
              }, {
                default: _withCtx(({ field, meta }) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-group icon-addon mb-4", meta.validated && !meta.valid ? 'has-error border-danger' : ''])
                  }, [
                    _hoisted_9,
                    _createElementVNode("input", _mergeProps(field, {
                      type: "text",
                      id: "Email",
                      placeholder: " ",
                      class: "form-control",
                      autocomplete: "off"
                    }), null, 16),
                    _createVNode(_component_ErrorMessage, {
                      class: "text-danger",
                      name: "Email"
                    })
                  ], 2)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              (!_ctx.email_sent)
                ? (_openBlock(), _createElementBlock("p", _hoisted_10, _hoisted_13))
                : (_openBlock(), _createElementBlock("p", _hoisted_14, _hoisted_17))
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("button", {
                class: "btn btn-primary btn-block rounded-3 btn-md my-3 text-uppercase fw-bold small",
                disabled: !_ctx.EmailAddress
              }, _hoisted_21, 8, _hoisted_19)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit"])
      ])
    ])
  ]))
}